import React, { PureComponent } from 'react';

import { Field } from 'redux-form';

import withIntl from '../../../../../../../../shared/intl-hoc';

import SelectField from '../../../../../../../../shared/form-elements/select/field';

import { getCurrencyIcon } from '../../../../../../../../../../../shared/js/get-currency-icon';

class AddPayoutSystemButton extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isAddButtonDisplayed: true
		};

		this.toggleAddButtonDisplayed = this.toggleAddButtonDisplayed.bind(this);
	}

	toggleAddButtonDisplayed() {
		this.setState((state) => ({ isAddButtonDisplayed: !state.isAddButtonDisplayed }));
	}

	getOptions() {
		return this.props.allowedPayoutSystems.map((payoutSystem) => ({
			value: payoutSystem,
			label: `${payoutSystem.title} (${getCurrencyIcon(payoutSystem.currency)})`
		}));
	}

	render() {
		const { intl, addPayoutSystemSettingField } = this.props;
		const { toggleAddButtonDisplayed } = this;

		return (
			<div>
				{this.state.isAddButtonDisplayed ? (
					<div
						className='add-system'
						onClick={this.toggleAddButtonDisplayed}
					>
						<span className='title'>
							{intl('Add payout system')}
						</span>
					</div>
				) : (
					<Field
						name='payout-system'
						component={SelectField}
						placeholder={intl('Add payout system')}
						options={this.getOptions()}
						onChange={(e) =>  {
							toggleAddButtonDisplayed();
							addPayoutSystemSettingField(e[0].value);
						}}
						multi={false}
						searchable={false}
					/>
				)}
			</div>
		);
	}
}

export default withIntl(AddPayoutSystemButton);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/payout-settings/payout-settings-form/affiliate-payout-system-settings/add-payout-system-button/main.js